// extracted by mini-css-extract-plugin
export var btn = "hero-module--btn--1203d";
export var heroImage = "hero-module--heroImage--b4bfb";
export var home = "hero-module--home--91ddb";
export var pageChild = "hero-module--pageChild--efeab";
export var pageHeader = "hero-module--pageHeader--6be83";
export var pageHeaderAlt = "hero-module--pageHeader--alt--2f253";
export var pageHeaderTitle = "hero-module--pageHeaderTitle--77193";
export var single = "hero-module--single--38b76";